import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import FormFieldText from "./FormFieldText";

function FormFieldCurrency(props) {
  const { name, meta } = props;

  let placeholder = get(meta, "placeholder", null);

  if (!placeholder) {
    placeholder = "Enter a currency";
  }

  return <FormFieldText {...props} name={name} meta={{ ...meta, placeholder }} />;
}

FormFieldCurrency.propTypes = {
  name: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
};

export default FormFieldCurrency;
